/* This code is defining several Yup validation schemas for different forms in a web application. Yup
is a JavaScript library for schema validation. Each schema defines the validation rules for a
specific form, such as sign up, login, forgot password, password reset, and event creation. The
validation rules include checking for required fields, valid email addresses, minimum password
length, positive numbers, and integer values. These schemas can be used to validate user input
before submitting it to the server. */
import * as Yup from "yup";

export const SignUpSchema = Yup.object().shape({
  phoneNumber: Yup.string().required("Phone Number is required"),
});
export const VerifierSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Email address should be valid")
    .required("Email is required"),
});
export const TeamMemberSchema = Yup.object().shape({
  email: Yup.string().trim().email("Email address should be valid").required("Email is required"),
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
});
export const SignUpOrganizerSchema = Yup.object().shape({
  phoneNumber: Yup.string().required("Phone Number is required"),
  email: Yup.string()
    .trim()
    .email("Email address should be valid")
    .required("Email is required"),
  name: Yup.string().required("Organizer Name is required"),
});

export const LoginSchema = Yup.object().shape({
  phoneNumber: Yup.string().required("Phone Number is required"),
});
export const LoginByEmailSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Email address should be valid")
    .required("Email is required"),
});
export const LoginVerifierSchema = Yup.object().shape({
  password: Yup.string().required("Code is required"),
});

export const forgotSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Email address should be valid")
    .required("Email is required"),
});

export const PasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .min(8, "At least 8 characters")
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
      "Password must include at least one uppercase letter, one lowercase letter, one digit, and one special character(@$!%*?&)"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

export const createEventSchema = Yup.object().shape({
  eventName:Yup.string().required("Event Name is required"),
  // eventType:Yup.mixed().required("At least one event tag is required"),
  // ticketTypes:Yup.mixed().required("At least one ticket type is required"),
  // ticketImage:Yup.string().required("Ticket Image is required"),
  // description: Yup.string().required("Description is required"),
  endDate: Yup.string().required("End date is required"),
  eventImage: Yup.string().required("Event image is required"),
  location: Yup.string().required("Location is required"),
  startDate: Yup.string().required("Start date is required"),
  startTime: Yup.string().required("Start time is required"),
  latitude: Yup.number().required("Select location from the google maps dropdown. You can't just write it out. If the dropdwon doesn't show up please REFRESH THE PAGE. We are working on fixing this, sorry for the inconvenience")
});

